import {
  UPDATE_LOGININFO,
  GET_LOGININFO,
  CHANGE_LOGININFO_WARD,
  UPDATE_WARDINFO,
  GET_WARDINFO,
  INIT_LOGIN_INFO,
} from '../../constant';

const updateWardinfoAction = (flag, hospitalName, wardName, hospitalId, wardId, hospCode) => ({
  type: UPDATE_WARDINFO,
  data: { flag, hospitalName, wardName, hospitalId, wardId, hospCode },
});

const getWardinfoAction = () => ({
  type: GET_WARDINFO,
  data: '',
});

const changeWardInfoAction = (ward) => ({
  type: CHANGE_LOGININFO_WARD,
  data: { ward },
});

const updateLoginInfoAction = (data) => ({
  type: UPDATE_LOGININFO,
  data,
});

const getLoginInfoAction = () => ({
  type: GET_LOGININFO,
});

const initLoginInfoAction = () => ({
  type: INIT_LOGIN_INFO,
});

export {
  updateWardinfoAction,
  getWardinfoAction,
  changeWardInfoAction,
  updateLoginInfoAction,
  getLoginInfoAction,
  initLoginInfoAction,
};
